let def_logo_url = 'https://cdn.shopify.com/s/files/1/2352/1061/t/28/assets/team-logo.svg';

// create manipulation sliders for logo
let size_range, rot_range, pos_x_range, pos_y_range, int_int, ctr_sliders, ctr_visible = false;
let obj_tgt = ['.wu-logo-jacket div','.wu-logo-leg div'], ctr_vals=[[1, 0, -125,-65], [1, 0, -115, -100]];
let ctrl_log_init = [[1, 0, -125, -65], [1, 0, -115, -100]];

let rx_range = [{'min': -368, 'max': 368},{'min': -240, 'max': 240}]
let ry_range = [{'min': -115, 'max': 115}, {'min': -155, 'max': 165}]
				//    jersey logo			  pants logo	

 
// create manipulation sliders for team name
let size_range_team, rot_range_team, pos_x_range_team, pos_y_range_team, int_int_team, ctr_sliders_team, ctr_visible_team = false;
let obj_tgt_team = ['#wu-name-jacket div','#wu-name-leg div'], ctr_vals_team=[[1, 0, 158, -40], [1, 90, -210, -95]];


let rx_range_team = [{'min': -270, 'max': 270}, {'min': -220, 'max': 220}]
let ry_range_team = [{'min': -125, 'max': 125}, {'min': -165, 'max': 165}]
				//    jersey text					pants text


	function chekFileType() {

		var def_ext = 'else';
		var ext = this.value.split('.').slice(-1).pop()

		switch (ext) {
			case 'png':
			    def_ext = 'png'
				break;
			case 'jpg':
				def_ext = 'jpg'
				break;
			case 'svg':
				def_ext = 'svg'
				break;
		}

		if(def_ext == 'else') {
			alert('Only png, jpg or svg files are allowed !');
			this.value = '';
		} else {

			$('.u-logo'+currpart+' div').remove();

			$('[name=ctr-rad]').eq(curblpage).prop('checked', true);

            //reset logo upload sliders

            ctr_vals[curblpage] = ctrl_log_init[curblpage];
            setTimeout(setManuTarget, 200);

		}
	}

	function fitTeamNames(){

			let fhf = $('.team-name:eq(0) div').height();
			let fwf = $('.team-name:eq(0) div').width();

			$('.team-name:eq(0) div').css({
				'margin-top': 0,
				'margin-left': -fwf/2
			})

			let fh = $('.team-name:eq(1) div').height();
			let fw = $('.team-name:eq(1) div').width();

			$('.team-name:eq(1) div').css({
				'margin-top': 0,
				'margin-left': -fw/2
			})

	}

	function setObjPosition(ctr_tgt, part_tgt) {  

		let val = ctr_tgt[curblpage];

		$(part_tgt[curblpage]).css({
			'transform': 'scale('+val[0]+') rotate('+val[1]+'deg)',
			'left': val[2],
			'top': val[3]
		})
	}

	function createManipulationUI() {

		$('#q-file1').imageLoader({
				'show': '.u-logo-jacket'
		});
      
      	$('#q-file2').imageLoader({
				'show': '.u-logo-leg'
		});

		$('#q-file1, #q-file2').change(chekFileType);
      

		// reset objects size and position

		// TEAM NAME FRONT

		$('#team-input').bind('keyup',fitTeamNames)

		$('#wu-name-jacket').css({
			'width': 0,
			'height': 0,
			'left': 320,
			'top': 220
		})

		$('#wu-name-jacket div').css({
			'position': 'absolute',
			'margin-top': 0,
			'left': 160,
			'top': -40
		})

		$('#wu-name-leg').css({
			'width': 0,
			'height': 0,
			'left': 320,
			'top': 460
		})

		$('#wu-name-leg div').css({
			'position': 'absolute',
      		'margin-top': 0,
			'left': -210,
			'top': -94
		})

		//fitTeamNames();

        //////////////////////////////////////////////////////////////////

        ////////////////////////////
        //  Scale  range slider  Team //
        ////////////////////////////

		size_range_team = document.getElementById('set-size-team')

		noUiSlider.create(size_range_team, {
			start: 1 , // 4 handles, starting at...
			margin: 0, // Handles must be at least 300 apart
			connect: [true, false], // Display a colored bar between the handles
			direction: 'rtl', // Put '0' at the bottom of the slider
			orientation: 'vertical', // Orient the slider vertically
			behaviour: 'tap-drag', // Move handle on tap, bar is draggable
			step: 0.1,
			tooltips: true,
			// format: {
			// 	      to: function ( value ) {
			// 	        return value.toFixed(1);
			// 	      },
			// 	      from: function ( value ) {
			// 	        return value;
			// 	      }
			// 	    },
			range: {
				'min': 0.1,
				'max': 4
			}
		});


		size_range_team.noUiSlider.on('update', function( values ) {
			$(size_range_team).find('.noUi-tooltip').show();
			ctr_vals_team[curblpage][0] = size_range_team.noUiSlider.get();
			setObjPosition(ctr_vals_team, obj_tgt_team);
		})

		size_range_team.noUiSlider.on('change', function( values ) {
			$(size_range_team).find('.noUi-tooltip').hide();
			ctr_vals_team[curblpage][0] = size_range_team.noUiSlider.get();
			setObjPosition(ctr_vals_team, obj_tgt_team);
		})

        $(size_range_team).find('.noUi-tooltip').hide();

		///////////////////////////////
        //  Rotation  range slider  Team //
        ///////////////////////////////

		rot_range_team = document.getElementById('set-rot-team')

		noUiSlider.create(rot_range_team, {
			start: 0 , // 4 handles, starting at...
			margin: 0, // Handles must be at least 300 apart
			connect: [true, false], // Display a colored bar between the handles
			direction: 'rtl', // Put '0' at the bottom of the slider
			orientation: 'vertical', // Orient the slider vertically
			behaviour: 'tap-drag', // Move handle on tap, bar is draggable
			step: 5,
			tooltips: true,
			// format: {
			// 	      to: function ( value ) {
			// 	        return value.toFixed(0);
			// 	      },
			// 	      from: function ( value ) {
			// 	        return value;
			// 	      }
			// 	    },
			range: {
				'min': -180,
				'max': 180
			}
		});

		$(rot_range_team).find('.noUi-tooltip').hide();

		rot_range_team.noUiSlider.on('update', function( values ) {
			$(rot_range_team).find('.noUi-tooltip').show();
			ctr_vals_team[curblpage][1] = parseInt(rot_range_team.noUiSlider.get());
			setObjPosition(ctr_vals_team, obj_tgt_team);
		})

		rot_range_team.noUiSlider.on('change', function( values ) {
			$(rot_range_team).find('.noUi-tooltip').hide();
			ctr_vals_team[curblpage][1] = parseInt(rot_range_team.noUiSlider.get());
			setObjPosition(ctr_vals_team, obj_tgt_team);
		})

        ////////////////////////
        //  X range slider Team //
        ///////////////////////

		pos_x_range_team = document.getElementById('set-posx-team')

		noUiSlider.create(pos_x_range_team, {
			start: 0 , // 4 handles, starting at...
			margin: 0, // Handles must be at least 300 apart
			connect: [true, false], // Display a colored bar between the handles
			direction: 'ltr', // Put '0' at the bottom of the slider
			orientation: 'vertical', // Orient the slider vertically
			behaviour: 'tap-drag', // Move handle on tap, bar is draggable
			step: 1,
			tooltips: true,
			// format: {
			// 	      to: function ( value ) {
			// 	        return value.toFixed(0);
			// 	      },
			// 	      from: function ( value ) {
			// 	        return value;
			// 	      }
			// 	    },
			range: {
				'min': -325,
				'max': 325
			}
		});

		$(pos_x_range_team).find('.noUi-tooltip').hide();

		pos_x_range_team.noUiSlider.on('update', function( values ) {
			$(pos_x_range_team).find('.noUi-tooltip').show();
			ctr_vals_team[curblpage][2] = parseInt(pos_x_range_team.noUiSlider.get());
			setObjPosition(ctr_vals_team, obj_tgt_team);
		})

		pos_x_range_team.noUiSlider.on('change', function( values ) {
			$(pos_x_range_team).find('.noUi-tooltip').hide();
			ctr_vals_team[curblpage][2] = parseInt(pos_x_range_team.noUiSlider.get());
			setObjPosition(ctr_vals_team, obj_tgt_team);
		})

		$('.set-holder-team').find('.noUi-tooltip').hide();
      
        ////////////////////////
        //  Y range slider Team//
        ///////////////////////

		pos_y_range_team = document.getElementById('set-posy-team')

		noUiSlider.create(pos_y_range_team, {
			start: 0 , // 4 handles, starting at...
			margin: 0, // Handles must be at least 300 apart
			connect: [true, false], // Display a colored bar between the handles
			direction: 'ltr', // Put '0' at the bottom of the slider
			orientation: 'vertical', // Orient the slider vertically
			behaviour: 'tap-drag', // Move handle on tap, bar is draggable
			step: 1,
			tooltips: true,
			// format: {
			// 	      to: function ( value ) {
			// 	        return value.toFixed(0);
			// 	      },
			// 	      from: function ( value ) {
			// 	        return value;
			// 	      }
			// 	    },
			range: {
				'min': -170,
				'max': 170
			}
		});

		$(pos_y_range_team).find('.noUi-tooltip').hide();

		pos_y_range_team.noUiSlider.on('update', function( values ) {
			$(pos_y_range_team).find('.noUi-tooltip').show();
			ctr_vals_team[curblpage][3] = parseInt(pos_y_range_team.noUiSlider.get());
			setObjPosition(ctr_vals_team, obj_tgt_team);
		})

		pos_y_range_team.noUiSlider.on('change', function( values ) {
			$(pos_y_range_team).find('.noUi-tooltip').hide();
			ctr_vals_team[curblpage][3] = parseInt(pos_y_range_team.noUiSlider.get());
			setObjPosition(ctr_vals_team, obj_tgt_team);
		})

		$('.set-holder-team').find('.noUi-tooltip').hide();

		ctr_sliders_team = [];
		ctr_sliders_team.push(size_range_team, rot_range_team, pos_x_range_team, pos_y_range_team)

        ////////////////////////////////////////////////////////////////////////////////////////

		////////////////////////////
        //  Scale  range slider  Logo //
        ////////////////////////////

		size_range = document.getElementById('set-size')

		noUiSlider.create(size_range, {
			start: 1 , // 4 handles, starting at...
			margin: 0, // Handles must be at least 300 apart
			connect: [true, false], // Display a colored bar between the handles
			direction: 'rtl', // Put '0' at the bottom of the slider
			orientation: 'vertical', // Orient the slider vertically
			behaviour: 'tap-drag', // Move handle on tap, bar is draggable
			step: 0.1,
			tooltips: true,
			// format: {
			// 	      to: function ( value ) {
			// 	        return value.toFixed(1);
			// 	      },
			// 	      from: function ( value ) {
			// 	        return value;
			// 	      }
			// 	    },
			range: {
				'min': 0.1,
				'max': 4
			}
		});

		$(size_range).find('.noUi-tooltip').hide();

		size_range.noUiSlider.on('update', function( values ) {
			$(size_range).find('.noUi-tooltip').show();
			ctr_vals[curblpage][0] = size_range.noUiSlider.get();
			setObjPosition(ctr_vals, obj_tgt);
		})

		size_range.noUiSlider.on('change', function( values ) {

			$(size_range).find('.noUi-tooltip').hide();
			ctr_vals[curblpage][0] = size_range.noUiSlider.get();
			setObjPosition(ctr_vals, obj_tgt);
		})

		///////////////////////////////
        //  Rotation  range slider  Logo //
        ///////////////////////////////

		rot_range = document.getElementById('set-rot')

		noUiSlider.create(rot_range, {
			start: 0 , // 4 handles, starting at...
			margin: 0, // Handles must be at least 300 apart
			connect: [true, false], // Display a colored bar between the handles
			direction: 'rtl', // Put '0' at the bottom of the slider
			orientation: 'vertical', // Orient the slider vertically
			behaviour: 'tap-drag', // Move handle on tap, bar is draggable
			step: 5,
			tooltips: true,
			// format: {
			// 	      to: function ( value ) {
			// 	        return value.toFixed(0);
			// 	      },
			// 	      from: function ( value ) {
			// 	        return value;
			// 	      }
			// 	    },
			range: {
				'min': -180,
				'max': 180
			}
		});

		$(rot_range).find('.noUi-tooltip').hide();

		rot_range.noUiSlider.on('update', function( values ) {
			$(rot_range).find('.noUi-tooltip').show();
			ctr_vals[curblpage][1] = parseInt(rot_range.noUiSlider.get());
			setObjPosition(ctr_vals, obj_tgt);
		})

		rot_range.noUiSlider.on('change', function( values ) {
			$(rot_range).find('.noUi-tooltip').hide();
			ctr_vals[curblpage][1] = parseInt(rot_range.noUiSlider.get());
			setObjPosition(ctr_vals, obj_tgt);
		})

        ////////////////////////
        //  X range slider logo //
        ///////////////////////

		pos_x_range = document.getElementById('set-posx')

		noUiSlider.create(pos_x_range, {
			start: 0 , // 4 handles, starting at...
			margin: 0, // Handles must be at least 300 apart
			connect: [true, false], // Display a colored bar between the handles
			direction: 'ltr', // Put '0' at the bottom of the slider
			orientation: 'vertical', // Orient the slider vertically
			behaviour: 'tap-drag', // Move handle on tap, bar is draggable
			step: 1,
			tooltips: true,
			// format: {
			// 	      to: function ( value ) {
			// 	        return value.toFixed(0);
			// 	      },
			// 	      from: function ( value ) {
			// 	        return value;
			// 	      }
			// 	    },
			range: {
				'min': -133,
				'max': 325
			}
		});

		$(pos_x_range).find('.noUi-tooltip').hide();

		pos_x_range.noUiSlider.on('update', function( values ) {
			$(pos_x_range).find('.noUi-tooltip').show();
			ctr_vals[curblpage][2] = parseInt(pos_x_range.noUiSlider.get());
			setObjPosition(ctr_vals, obj_tgt);
		})

		pos_x_range.noUiSlider.on('change', function( values ) {
			$(pos_x_range).find('.noUi-tooltip').hide();
			ctr_vals[curblpage][2] = parseInt(pos_x_range.noUiSlider.get());
			setObjPosition(ctr_vals, obj_tgt);
		})

		$('.set-holder').find('.noUi-tooltip').hide();
      
        ////////////////////////
        //  Y range slider logo//
        ///////////////////////

		pos_y_range = document.getElementById('set-posy')

		noUiSlider.create(pos_y_range, {
			start: 0 , // 4 handles, starting at...
			margin: 0, // Handles must be at least 300 apart
			connect: [true, false], // Display a colored bar between the handles
			direction: 'ltr', // Put '0' at the bottom of the slider
			orientation: 'vertical', // Orient the slider vertically
			behaviour: 'tap-drag', // Move handle on tap, bar is draggable
			step: 1,
			tooltips: true,
			// format: {
			// 	      to: function ( value ) {
			// 	        return value.toFixed(0);
			// 	      },
			// 	      from: function ( value ) {
			// 	        return value;
			// 	      }
			// 	    },
			range: {
				'min': -170,
				'max': 155
			}
		});

		$(pos_y_range).find('.noUi-tooltip').hide();

		pos_y_range.noUiSlider.on('update', function( values ) {
			$(pos_y_range).find('.noUi-tooltip').show();
			ctr_vals[curblpage][3] = parseInt(pos_y_range.noUiSlider.get());
			setObjPosition(ctr_vals, obj_tgt);
		})

		pos_y_range.noUiSlider.on('change', function( values ) {
			$(pos_y_range).find('.noUi-tooltip').hide();
			ctr_vals[curblpage][3] = parseInt(pos_y_range.noUiSlider.get());
			setObjPosition(ctr_vals, obj_tgt);
		})

		$('.set-holder').find('.noUi-tooltip').hide();

		ctr_sliders = [];
		ctr_sliders.push(size_range, rot_range, pos_x_range, pos_y_range)


		//select manipulated object and set initial values

        let query = window.location.href.indexOf('#')!=-1?window.location.href.split('#')[1]:window.location.href.split('=')[1]

        if(query==undefined || query==''){
            ctr_vals=[[1, 0, -125,-65], [1, 0, -115, -100]]
            ctr_vals_team=[[1, 0, 158, -40], [1, 90, -210, -95]];
        }else{
          
            let cv = dparts[8].split('_')
            ctr_vals = [];
            ctr_vals = [
              [cv[0],cv[1],cv[2],cv[3]],
              [cv[4],cv[5],cv[6],cv[7]]
            ];
          
            ctr_vals_team = [];
            ctr_vals_team = [
              [cv[8],cv[9],cv[10],cv[11]],
              [cv[12],cv[13],cv[14],cv[15]]
            ];
        }
      
        for(j=0; j<ctr_vals.length; j++) { 
          curblpage = j;
          ctr_sliders.forEach(function(e, i) {
            e.noUiSlider.set(Number(ctr_vals[j][i]))
            $('.noUi-tooltip').hide();
          })
        }

        for(j=0; j<ctr_vals_team.length; j++) { 
          curblpage = j;
          ctr_sliders_team.forEach(function(e, i) {
            e.noUiSlider.set(Number(ctr_vals_team[j][i]))
            $('.noUi-tooltip').hide();
          })
        }

        // set bling page to first one
        curblpage = 0;
        setManuTarget();

	}

function setManuTarget() {

		ctr_sliders.forEach(function(e, i) {
			e.noUiSlider.set(ctr_vals[curblpage][i])
		})

		pos_x_range.noUiSlider.updateOptions({range: rx_range[curblpage]});
		pos_y_range.noUiSlider.updateOptions({range: ry_range[curblpage]});

        ctr_sliders_team.forEach(function(e, i) {
			e.noUiSlider.set(ctr_vals_team[curblpage][i])
		})

		pos_x_range_team.noUiSlider.updateOptions({range: rx_range_team[curblpage]});
		pos_y_range_team.noUiSlider.updateOptions({range: ry_range_team[curblpage]});

        setTimeout(function() {$('.noUi-tooltip').hide();},100)

        fitTeamNames();

	}

